module.exports = __webpack_public_path__ + "img/model_55_zh.6a300660.jpg";